import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import FloatLabelInput from "../../../components/FloatingLabel";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import { getVehicleInfo } from "../../../utils/backend";
import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";
import FloatDateInput from "../../../components/FloatDateInput";
import FloatingSelect from "../../../components/FloatingSelect";

const AddOnGeneraliDriver = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const getVehicleInfo = useGetVehicleInfo();
	const selectedPlan = useGetCarPlan();

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const selectedAddOn = location.state?.addOn;

	const genderOptions = [
		// { value: "", label: "Please select Gender" },
		{ value: "M", label: "Male" },
		{ value: "F", label: "Female" },
	];

	const relationOptions = [
		// { value: "", label: "Please select relationship" },
		{ value: "INSD", label: `The Policy Holder` },
		{ value: "SIB", label: `Siblings` },
		{ value: "PARE", label: `Parents` },
		{ value: "SPOU", label: `Spouse` },
		{ value: "CHLD", label: `Children` },
		{ value: "EEE", label: `Friends` },
	];

	const initialDrivers = JSON.parse(localStorage.getItem("adddriver"));
	const [adddriver, setAddDriver] = useState(initialDrivers || []);

	useEffect(() => {
		// Save to localStorage whenever drivers change
		localStorage.setItem("adddriver", JSON.stringify(adddriver));
	}, [adddriver]);

	if (!selectedAddOn) {
		return (
			<div className="content">
				<h3>No Add-on Selected</h3>
				<Button label="Go Back" onClick={() => navigate(-1)} />
			</div>
		);
	}

	const handleInputChange = (index, field, value) => {
		const newDrivers = [...adddriver];
		newDrivers[index] = {
			...newDrivers[index],
			[field]: value
		};
		setAddDriver(newDrivers);
	};

	const addDriverField = () => {
		const newDriver = {
			name: "",
			icnumber: "",
			drvdob: "",
			drvgender: "",
			drvrel: ""
		};
		setAddDriver([...adddriver, newDriver]);
	};

	const removeDriverField = (index) => {
		const newDrivers = adddriver.filter((_, i) => i !== index);
		setAddDriver(newDrivers);
	};

	const handleReturnClick = (e) => {
		e.preventDefault();
		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		navigate(
			policyId
				? `/get-quote/add-on-others?policy_id=${policyId}`
				: `/get-quote/add-on-others`,
			{
				replace: true,
				state: {
					...selectedAddOn,
					adddriver, // Pass the sum_insured value here
				},
			}
		);
	};

	function formatDateToYYYYMMDD(date) {
		if (!(date instanceof Date)) return '';
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	}

	return (
		<div className="content">
			<div className="get-quote-container">
				<h3>{`Drivers for ${selectedAddOn.title}`}</h3>

				<div className="add-on-details border-radius-10 w-100 mb-8rem">
					<Button
						label="Add Driver"
						className="btn-secondary-fill w-100 add-nominate-button mb-2"
						onClick={addDriverField}
					/>

					{adddriver.map((driver, index) => (
						<div
							key={index}
							className="mb-2 d-flex align-items-center"
						>
							<FloatLabelInput
								className="my-2"
								label={
									selectedPlan.insurer_name !== "TOKIO MARINE" && index === 0
										? "Owner Name"
										: `Driver ${index + 1} Name`
								}
								value={driver.name}
								onChange={(e) =>
									handleInputChange(index, 'name', e.target.value)
								}
								type="text"
								disabled={selectedPlan.insurer_name !== "TOKIO MARINE" && index === 0}
							/>
							
							<FloatLabelInput
								className="my-2"
								label="Identification Number"
								value={driver.icnumber}
								onChange={(e) =>
									handleInputChange(index, 'icnumber', e.target.value)
								}
								placeholder=""
							/>

							<FloatDateInput
								className="my-2"
								label="Date of Birth"
								value={driver.drvdob ? new Date(driver.drvdob) : null} // Convert to Date for UI
								onChange={(e) => {
									// Convert to yyyy-mm-dd string before storing
									const formattedDate = formatDateToYYYYMMDD(e.value);
									handleInputChange(index, 'drvdob', formattedDate);
								}}
								dateFormat="dd-mm-yy"
								showIcon
							/>

							<FloatingSelect
								className="my-2"
								label="Gender"
								options={genderOptions}
								value={driver.drvgender}
								onChange={(e) =>
									handleInputChange(index, 'drvgender', e.target.value)
								}
							/>

							<FloatingSelect
								className="my-2"
								label="Relationship"
								options={relationOptions}
								value={driver.drvrel}
								onChange={(e) =>
									handleInputChange(index, "drvrel", e.target.value)
								}
							/>

							{index > 0 && (
								<Button
									label="Remove"
									className="p-button-danger w-100 mt-2"
									onClick={() => removeDriverField(index)}
								/>
							)}

							{index !== adddriver.length - 1 && <hr style={{ border: 0, borderTop: "1px solid #ccc" }} className="my-3 w-100" />}
						</div>
					))}
				</div>

				<div className={`sticky-bottom `}>
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						{/* Selected Plan and Logo Section */}
						<div className="plan-details">
							<span className="text-left formatted-text">
								{`Selecting Add-Ons for`}
							</span>
							<br />
							<span className="fw-bold color-heading">
								{selectedAddOn.title}
							</span>
							<p className="my-0 fw-bold insurer-name"></p>
						</div>
						<div className="col-sm-6 w-50"></div>
					</div>
					<hr />
					<Button
						label="Return add-ons"
						className="btn-primary"
						onClick={(e) => handleReturnClick(e)}
					/>
					<BottomMessagePopUp
						message={errorMessage}
						type="error"
						isVisible={isErrorVisible}
						onClose={() => setIsErrorVisible(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default AddOnGeneraliDriver;
